module.exports = __webpack_public_path__ + "static/media/HelvNeue55_Cyr.5e5d1cf6.ttf";